import { render, staticRenderFns } from "./TagsEditorModal.vue?vue&type=template&id=1d4c17b9&scoped=true"
import script from "./TagsEditorModal.vue?vue&type=script&lang=js"
export * from "./TagsEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TagsEditorModal.vue?vue&type=style&index=0&id=1d4c17b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c17b9",
  null
  
)

export default component.exports